var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectsManagementBorder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "project-setting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34226034,3.6 C5.58985427,3.6 5.83207423,3.66563934 6.04470445,3.78897627 L6.04470445,3.78897627 L9.88069227,6.6 L18,6.6 C18.3865993,6.6 18.7365993,6.75670034 18.9899495,7.01005051 C19.2432997,7.26340068 19.4,7.61340068 19.4,8 L19.4,8 L19.4,16 C19.4,16.3865993 19.2432997,16.7365993 18.9899495,16.9899495 C18.7365993,17.2432997 18.3865993,17.4 18,17.4 L18,17.4 L2,17.4 C1.61340068,17.4 1.26340068,17.2432997 1.01005051,16.9899495 C0.756700338,16.7365993 0.6,16.3865993 0.6,16 L0.6,16 L0.6,5 C0.6,4.63238964 0.741653984,4.29784761 0.973430109,4.04806569 C1.20260382,3.80108837 1.51976517,3.63669138 1.87523093,3.60544799 L1.87523093,3.60544799 Z",
    id: "Rectangle-3",
    stroke: "#3B7FF5",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 4.5,
    x2: 18.5,
    y2: 4.5,
    id: "Path-23",
    stroke: "#3B7FF5",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsManagementBorder);
export default __webpack_public_path__ + "static/media/projects-management-border.5fdb5a6cdd8121fcb9ae0de0c13cead9.svg";
export { ForwardRef as ReactComponent };